/*
 *###############################################################################
 *Module Name                   : CashBookSummary.js                               #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  W M Shanika Chamodi                          #
 *Date                          :  Friday, December 12th 2022, 1:16:56 pm         #
 *Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */
import React, { useState, useEffect } from "react"
import { Row, Col, Button } from "reactstrap"
import Switch from "react-switch"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import ReactPaginate from "react-paginate"
import DPDropDown from "framework/components/DPDropDown"

const Offsymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      No
    </div>
  )
}

const OnSymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      Yes
    </div>
  )
}

const CashBookSummary = React.memo(({ DataRow, Disabled, LocationCode, CashBookDate, TotalSummaryValue,
  TotalTrnasactionValue, rowsCreditSummary, rowsDebitSummary, handleClear, setrowsSummary,
  handleRowClick, csbList, setCashBookType, cashBookType, SetCashBookSummary }) => {

  const [postsPerPage] = useState(15)
  const [currentPage, setCurrentPage] = useState(1)

  useEffect(() => {
    setCurrentPage(1)
  }, [handleClear])


  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
    console.log("Page clicked:", event.selected + 1);
  };

  const changeRowValueChanges = (value, id, element) => {

    const newObject = { ...DataRow[id], [element]: value };
    setrowsSummary(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[id] = newObject;
      return newDataRow;
    });
  };

  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = DataRow.slice(indexOfFirstPost, indexOfLastPost)
  return (
    <React.Fragment>
      <Row className="mb-4">
        <Col sm={12} md={6} className="mb-6-sm">
          <DPDropDown
            labelText={"Select Cash Book"}
            optionGroup={csbList}
            selectedGroup={cashBookType}
            onChange={e => {
              setCashBookType(e["value"])
              SetCashBookSummary(e["value"]);
            }}
            disabled={false}
          />
        </Col>
      </Row>
      <Row>
        {DataRow.length > 0 ? <Col sm={12} md={12} className="mb-12-sm">
          <table
            style={{ fontSize: "12px" }}
            id={"CashBookSummaryDet"}

          >
            <thead className="table-light-border">
              <tr>
                <th>Payment Mode</th>
                <th>Description</th>
                <th style={{ textAlign: "right" }}>Amount</th>
                <th style={{ textAlign: "right", width: "70px" }}>No of Transactions</th>
                <th style={{ textAlign: "left" }}>Checked</th>
              </tr>
            </thead>
            <tbody disabled={true}>

              {(currentPosts).map((row, key) => (
                <TableRow
                  FormRow={row}
                  Key={indexOfFirstPost + key}
                  Disabled={Disabled}
                  changeRowValueChanges={changeRowValueChanges}
                  DataTable={DataRow}
                  handleRowClick={handleRowClick}
                />
              ))}
            </tbody>
            <tfoot>
              <tr>
                <th style={{ textAlign: "left" }}>Total Amount</th>
                <th ></th>

                <th style={{ textAlign: "right" }}>
                  <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    labelText="Code"
                    textType="text"
                    maxLength="8"
                    textAlign="right"
                    disabled={true}
                    defaultValue="0.0"
                    value={TotalSummaryValue.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
                  ></DPTextBoxforgrid>
                </th>
                <th style={{ textAlign: "right" }}>
                  <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    labelText="Code"
                    textType="text"
                    maxLength="8"
                    textAlign="right"
                    disabled={true}
                    defaultValue="0.0"
                    value={TotalTrnasactionValue.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}

                  ></DPTextBoxforgrid>
                </th>
              </tr>

            </tfoot>
          </table>
        </Col> : null}
      </Row>
      <Row>
        <Col sm={6} md={6} className="mb-4-sm">
          <div className="mt-3 mb-3">
            <ReactPaginate
              previousLabel={'Previous'}
              nextLabel={'Next'}
              breakLabel={'...'}
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakClassName="page-item"
              breakLinkClassName="page-link"
              pageCount={Math.ceil(DataRow.length / postsPerPage)}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              forcePage={currentPage - 1}
              renderOnZeroPageCount={null}
              activeClassName={'active'}
              activeLinkClassName={'page-link'}
              containerClassName={'pagination justify-content-center pagination-sm'}
            />
          </div>
        </Col>
      </Row>
    </React.Fragment>
  )
})
export default CashBookSummary

const TableRow = ({ FormRow, Key, Disabled, changeRowValueChanges, handleRowClick }) => {

  return (

    <tr key={FormRow.id} >
      <td style={{ width: "100px" }}  >

        <Col md="12">
          <Button
            className="btn-sm"
            id={"btnPaymentcode" + Key}
            onClick={() => handleRowClick(FormRow.paymentcode)}
            style={{ width: "100px" }}
          >
            {FormRow.paymentcode}
          </Button>
        </Col>

      </td>
      <td style={{ width: "200px" }}>

        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"txtPaymentDescription" + Key}
            value={FormRow.paymentDescription}
          ></DPTextBoxforgrid>
        </Col>

      </td>
      <td style={{ width: "120px" }}>

        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            defaultValue="0.0"
            textAlign="right"
            id={"txtAmount" + Key}
            value={FormRow.amount}
            disabled={Disabled}

          ></DPTextBoxforgrid>
        </Col>

      </td>
      <td style={{ width: "120px" }}>

        <Col md="12">
          <div>
            <Row>
              <Col md="12">
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  defaultValue="0.0"
                  textAlign="right"
                  maxLength="10"
                  id={"txtNoofTran" + Key}
                  value={FormRow.noofTran}
                  disabled={true}

                ></DPTextBoxforgrid>
              </Col>
            </Row>
          </div>
        </Col>

      </td>
      <td style={{ width: "50px" }}>

        <Col md="12" style={{ textAlign: "left" }}>
          <Switch
            uncheckedIcon={<Offsymbol />}
            checkedIcon={<OnSymbol />}
            className="me-1 mb-sm-8 mb-2"
            onColor="#626ed4"
            height={23}
            handleDiameter={15}
            onChange={(e) => {
              changeRowValueChanges(e, Key, "state")
            }}
            checked={FormRow.state}
            id={"swInvActive" + Key}
            disabled={true}
          />
        </Col>

      </td>
    </tr>
  )
}
